import React, { FC } from 'react';
import styled from 'styled-components';

import { Link } from '~src/components/link';

import { Info } from '../info';
import { DrawerFooter } from '../modal';
import { Social } from '../social';

const Footer = styled(DrawerFooter)`
  padding: 1rem 3rem;
`;

const FooterContent = styled.div<{ isOpenContact: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  max-width: ${p => (p.isOpenContact ? `63em` : `53em`)};
  width: 100%;
  padding-top: 2em;
  border-top: 1px solid #000;
`;

const FooterInfo = styled.div``;

const InfoUp = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${p => p.theme.maxWidth.phone`
    flex-direction: column;
    align-items: baseline;
  `}
`;

const Contact = styled.button`
  font-size: 1em;
  font-weight: 600;
  text-transform: initial;
  color: #000;
  transition: color 0.2s ease-in-out;

  &:hover {
    opacity: 0.6;
  }
`;

const Privacy = styled(Link)`
  font-size: 1em;
  font-weight: 600;
  text-transform: initial;
  color: #000;
  transition: color 0.2s ease-in-out;
  ${p => p.theme.maxWidth.phone`
    margin-top: 0.5em;
  `}

  &:hover {
    opacity: 0.6;
  }
`;

const data = {
  contactLabel: `Kontaktirajte nas`,
};

type Props = {
  onOpenContact: () => void;
  isOpenContact: boolean;
};

export const MenuFooter: FC<Props> = ({ onOpenContact, isOpenContact }) => {
  return (
    <Footer>
      <FooterContent isOpenContact={isOpenContact}>
        <FooterInfo>
          <InfoUp>
            <Contact onClick={onOpenContact}>{data.contactLabel}</Contact>
            <Privacy to="politika-privatnosti">Politika privatnosti</Privacy>
          </InfoUp>
          <Info />
        </FooterInfo>
        <Social />
      </FooterContent>
    </Footer>
  );
};
